<template>
  <el-container class='box'>
    <div class="headerCom"> 
      <publicBreadCrumb :breadList="breadList"/>
      <publicFoldSearch :searchList='searchList' v-on:getSearchObj='getSearchObj' :rightEventList='rightEventList' @rightFunc='rightFunc'/>
     </div>
    <el-main class="listTabel">
      <BaseTable :data="tableData" :optimize='true'
          tooltip-effect="dark"
          :column="tableConfig" pagination :auto-scroll="true" :total="total" :page.sync="searchParams.current"
          :limit.sync="searchParams.size" @pagination="getList">
      </BaseTable>
    </el-main>
    <downCode ref='code' :curRow='curRow' />
  </el-container>
</template>

<script>
import {
  getWeChatAppList,
  outsideChainPage,
  outsideChainProjectPage,
  listHospitalAllPullDown,
  findIcdDiseaseList,
  publish
} from "./api";
import { DEEP_CLONE } from '@/utils/constants'
export default {
  components: {
    downCode: () => import("./component/downcode.vue")
  },
  props: {},
  data() {
    return {
      breadList:[{name:'运营管理'},{name:'外链链接'}],
      rightEventList:[{eventName:'渠道管理',eventValue:1},{eventName:'新增外链',eventValue:2}],
      // tableDataCode: [
      //   { size: "150*150", val: "150" },
      //   { size: "256*256", val: "256" },
      //   { size: "512*512", val: "512" },
      //   { size: "1024*1024", val: "1024" }
      // ],
      curRow: {},
      searchList: [
        {
          label: "链接名称",
          value: 1,
          paramName: "name",
          inputType: "input",
          maxNum: 20
        },
        {
          label: "小程序",
          value: 2,
          paramName: "appletId",
          inputType: "select",
          optionData: []
        },

        {
          label: "外链项目",
          value: 3,
          paramName: "outsideChainProjectId",
          inputType: "select",
          optionData: []
        },
        {
          label: "归属",
          value: 4,
          paramName: "belongId",
          inputType: "hospital",
          optionData: []
        },

        {
          label: "主适配病种",
          value: 5,
          paramName: "diseaseTypeId",
          inputType: "select", 
          optionData: []
        },
        {
          label: "更新日期",
          value: 6,
          paramName: "timeRange",
          inputType: "datetimerange",
          isTime:true,
          paramstartTime: "updateStartTime",
          paramEndTime: "updateEndTime"
        },
        {
          label: "状态",
          value: 7,
          paramName: "status",
          inputType: "select",
          default:0,
          optionData: [
            {
              label: "启用",
              value: 0
            },
            {
              label: "禁用",
              value: 1
            }
          ]
        },
        {
          label: "操作人",
          value: 8,
          paramName: "updateUserName",
          inputType: "input"
        },
        {
          label: "渠道",
          value: 9,
          paramName: "outsideChainChannelName",
          inputType: "input",
          maxlength:20
        }
      ],
      searchParams: {
        size: 10,
        current: 1, 
      }, 
      tableData: [],
      tableConfig: [ 
        {
          label: "链接名称",
          align: "center",
          prop: "name",
          showOverflowTooltip:true,
        },
        {
          label: "对应小程序",
          align: "center",
          prop: "appletName",
          size: "mini"
        },
        {
          label: "外链项目",
          align: "center",
          prop: "outsideChainProjectName" 
        },
        {
          label: "归属",
          align: "center",
          prop: "belongName" 
        },
        {
          label: "渠道",
          align: "center",
          prop: "outsideChainChannelName" 
        }, 
        {
          label: "主适配病种",
          align: "center",
          prop: "diseaseTypeName", 
        },
        {
          label: "更新日期",
          align: "center",
          prop: "updateTime", 
        },
        {
          label: "状态",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.status ? "禁用" : "启用"}
              </span>
            );
          }
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.onAddClick(scope.row.shortChainFullPath);
                    }
                  }
                },
                "复制链接"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.showDownLoad(scope.row);
                    }
                  }
                }, 
                "下载二维码" 
              ),
               h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.editClick(scope.row);
                    }
                  }
                }, 
                "编辑" 
              ),
               h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.enableTheClick(scope.row);
                    }
                  }
                },  
                scope.row.status == 1 ? "启用" : "禁用"
              )
            ]);
          }
        }
      ],
      total: 0
    };
  },

  watch: {},
  computed: {},
  methods: {
    editClick(data) {
      this.$router.push({
        path: "/termPage/updateOuterChain",
        query: { id: data.id, outsideChainChoiceId: data.outsideChainChoiceId }
      });
    },
    showDownLoad(row) {
      this.curRow = row;
      this.$refs.code.showDialogCode();
    },
    onAddClick(data) {
      this.$copyText(data)
        .then(result => {
          this.$message.success("复制成功");
        })
        .catch(err => {});
    },
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams; 
      this.searchParams = { ...this.searchParams, ...obj }; 
      this.getList();
    }, 
    getList() {
      outsideChainPage(this.searchParams)
        .then(result => {
          this.total = result.data.total;
          this.tableData = result.data.records;
        })
        .catch(err => {});
    },
    addOuterChain() {
      this.$router.push("/termPage/addOuterChain");
    },
    // handleSizeChange(value) {
    //   this.searchParams.size = value;
    //   this.getList();
    // },
    // handleCurrentChange(value) {
    //   this.searchParams.current = value;
    //   this.getList();
    // },
    enableTheClick(row) {
      //启用
      publish({ id: row.id }).then(res => {
        if (res.code == 0) {
          this.getList();
          if(scope.row.status){
            this.$message.success("启用成功");
          }else{
            this.$message.success("禁用成功");
          }
          
        }
      });
    },
    // disableClick(row) {
    //   //禁用
    //   publish({ id: row.id }).then(res => {
    //     if (res.code == 0) {
    //       this.getList();
    //       this.$message.success("禁用成功");
    //     }
    //   });
    // },
    rightFunc(item) {
      if(item.eventValue == 1){
         this.$router.push("/termPage/channelManagement");
      }else{
        this.$router.push("/termPage/addOuterChain");
      } 
    }, 
    setValueNull(e){ 
      this.searchParams.status = 0;
        // this.searchParamsNew.status = null;
    },
  },
  created() {
    getWeChatAppList(1)
      .then(result => {
        let arr = result.data.map(it => {
          return {
            label: it.name,
            value: it.appId
          };
        });
        // this.WeChatAppList = result.data
        this.searchList[1].optionData = arr;
      })
      .catch(err => {});
    outsideChainProjectPage({})
      .then(result => {
        let arr = result.data.map(it => {
          return {
            label: it.name,
            value: it.id
          };
        });
        // this.chainProjectList = result.data; 
        this.searchList[2].optionData = arr 
      })
      .catch(err => {});

    findIcdDiseaseList("")
      .then(result => {
        let arr = result.data.map(it => {
          return {
            label: it.suborderName,
            value: it.id,
            disabled:it.id == '36112'?true:false
          };
        });
        // this.diseaseArr = result.data;
        this.searchList[4].optionData = arr;
      })
      .catch(err => {}); 
    // this.getList();
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 20px;
}
.mr10{margin-right:10px;}
/deep/.el-form-item{
  margin-right:10px;
  margin-bottom:0;
}
/deep/.el-tag{
  margin-left:5px;
}
</style>